import axios from "axios";
import config from "../config";

export function getUsers(params) {
  return axios.get(`${config.api_url}/users?type=sidekick`, {
    params: params,
  });
}

export function getUser(id) {
  return axios.get(`${config.api_url}/users/${id}`, {});
}

export function createUser(data) {
  return axios.post(`${config.api_url}/users`, data);
}

export function updateUser(id, data) {
  return axios.put(`${config.api_url}/users/${id}`, data);
}

export function bulkUpdateAutoTranscribe(userSqids, autoTranscribe) {
  return axios.patch(`${config.api_url}/users/bulk-update-auto-transcribe`, {
    user_sqids: userSqids,
    auto_transcribe: autoTranscribe,
  });
}

export function bulkUpdateTimezone(userSqids, timezone) {
  return axios.patch(`${config.api_url}/users/bulk-update-timezone`, {
    user_sqids: userSqids,
    timezone: timezone || null,
  });
}

export function bulkUpdateMeetingNotesTemplate(userSqids, templateId) {
  return axios.patch(
    `${config.api_url}/users/bulk-update-meeting-notes-template`,
    {
      user_sqids: userSqids,
      meeting_notes_template_id: templateId || null,
    },
  );
}
